var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",attrs:{"data-ce":"true"}},[_c(_vm.editorTag,{ref:"editor",tag:"component",attrs:{"contenteditable":_vm.editMode},domProps:{"innerHTML":_vm._s(_vm.valueText)},on:{"focus":_vm.focus,"keydown":_vm.keydown,"paste":_vm.paste,"blur":_vm.blur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }